export const SHOW_LOADING = "SHOW_LOADING";
export const HIDE_LOADING = "HIDE_LOADING";

export const SET_CONFIRMINFO = "SET_CONFIRMINFO";

export const SET_ASSESSMENT_RESULT = "SET_ASSESSMENT_RESULT";

export const SET_USERNAME_OF_RESET_PASSWORD = "SET_USERNAME_OF_RESET_PASSWORD";